// Libraries
import React, {FunctionComponent, ReactElement} from 'react';
import {Form} from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { Rule } from 'antd/lib/form';

const { Item } = Form;


type FormItemComponentType = {
  initialValue?: any;
  label?: string;
  name?: string | (string | number)[];
  valuePropName?: string;
  hasFeedback?: boolean;
  required: boolean;
  withValueValidator?: boolean;
  className?: string;
  newRules?:  Rule[];
  dependencies?: NamePath[];
  child: ReactElement;
  getValueFromEvent?: (values: any) => any;
};
const FormItemComponent: FunctionComponent<FormItemComponentType> = (
  {
    initialValue, label, name, valuePropName, hasFeedback, required,
    withValueValidator, className, newRules, dependencies, child, getValueFromEvent,
  }) => {
  const rules: Array<object> = [{ required: required, message: 'Campo requerido' }];
  newRules?.map(rule => rules.push(rule));

  return (
    withValueValidator
    ?
      <Item label={label}
            name={name}
            valuePropName={valuePropName}
            className={'[&>div>div]:pb-1 [&>div>div>label]:text-sm [&>div>div>label]:font-medium ' +
              '[&>div>div>label]:text-grey-dkt-400 ' + className
            }
            rules={rules}
            getValueFromEvent={(value) => {
              return value ?? 0;
            }}
        >
        {child}
      </Item>
      :
      <Item label={label}
            name={name}
            valuePropName={valuePropName}
            className={'[&>div>div]:pb-1 [&>div>div>label]:text-sm [&>div>div>label]:font-medium ' +
              '[&>div>div>label]:text-grey-dkt-400 ' + className
            }
            dependencies={dependencies}
            initialValue={initialValue}
            hasFeedback={hasFeedback}
            getValueFromEvent={getValueFromEvent}
            rules={rules}>
        {child}
      </Item>
  );
}

FormItemComponent.defaultProps = {
  label: undefined,
  name: undefined,
  valuePropName: 'value',
  required: true,
  withValueValidator: false,
  className: '',
  child: <></>,
};

export default FormItemComponent;